import { isMacOS } from "../helpers/utils";
export enum AlignmentType {
  left = "left",
  right = "right",
  justify = "justify",
}

export enum RotateType {
  rotate_90_clockwise = "rotate_90_clockwise",
  rotate_90_anticlockwise = "rotate_90_anticlockwise",
  rotate_as_mirror = "rotate_as_mirror",
}

const AlignmentMenuActions = {
  title: "PROPERTIES_PANEL.ALIGNMENT",
  actionsList: [
    {
      label: "PROPERTIES_PANEL.LEFT",
      value: AlignmentType.left,
      key: "alignment",
    },
    {
      label: "PROPERTIES_PANEL.JUSTIFY",
      value: AlignmentType.justify,
      key: "alignment",
    },
    {
      label: "PROPERTIES_PANEL.RIGHT",
      value: AlignmentType.right,
      key: "alignment",
    },
  ],
};

function FlyToSelectionMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.FLY_TO_SELECTION",
    type,
    action: {
      label: "EDITOR.FLY_TO_SELECTION",
      value: "EDITOR.FLY_TO_SELECTION",
      key: "flyToSelection",
      type,
    },
  };
}

function CloneAndContinueMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.CLONE_AND_CONTINUE",
    type,
    action: {
      label: "EDITOR.CLONE_AND_CONTINUE",
      value: "EDITOR.CLONE_AND_CONTINUE",
      key: "cloneAndContinue",
      type,
    },
  };
}

function RepositionMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.REPOSITION",
    type,
    action: {
      label: "EDITOR.REPOSITION",
      value: "EDITOR.REPOSITION",
      key: "reposition",
      type,
    },
  };
}

function SaveAsTemplateMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.SAVE_AS_TEMPLATE",
    type,
    action: {
      label: "EDITOR.SAVE_AS_TEMPLATE",
      value: "EDITOR.SAVE_AS_TEMPLATE",
      key: "saveAsTemplate",
      type,
    },
  };
}

function RemoveMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.REMOVE",
    type,
    action: {
      label: "EDITOR.REMOVE",
      value: "EDITOR.REMOVE",
      key: "delete",
      type,
    },
  };
}

function MarkAsStartPointMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.MARK_AS_START_POINT",
    type,
    disabled: false,
    action: {
      label: "EDITOR.MARK_AS_START_POINT",
      value: "EDITOR.MARK_AS_START_POINT",
      key: "markAsStartPoint",
      type,
    },
  };
}

function DistributeShelfMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.DISTRIBUTE_SHELF",
    type,
    action: {
      label: "EDITOR.DISTRIBUTE_SHELF",
      value: "EDITOR.DISTRIBUTE_SHELF",
      key: "distributeShelf",
      type,
    },
  };
}

function RotateMenuActions(type: ObjectType) {
  return {
    title: "PROPERTIES_PANEL.ROTATE",
    type,
    actionsList: [
      {
        label: "EDITOR.ROTATE_90_CLOCKWISE",
        value: RotateType.rotate_90_clockwise,
        key: "rotate",
      },
      {
        label: "EDITOR.ROTATE_90_ANTICLOCKWISE",
        value: RotateType.rotate_90_anticlockwise,
        key: "rotate",
      },
      {
        label: "EDITOR.ROTATE_AS_MIRROR",
        value: RotateType.rotate_as_mirror,
        key: "rotate",
      },
    ],
  };
}

function AutoFitToDoorMenuAction(type: ObjectType) {
  return {
    label: "EDITOR.AUTO_FIT_TO_DOOR",
    type,
    action: {
      label: "EDITOR.AUTO_FIT_TO_DOOR",
      value: "EDITOR.AUTO_FIT_TO_DOOR",
      key: "autoFitToDoor",
      type,
    },
  };
}

export enum ObjectType {
  Grid = "grid",
  Door = "door",
  Shelf = "shelf",
  Rod = "rod",
  LateralRod = "lateral_rod",
  CurvedRod = "curved_rod",
  Allocation = "allocation",
  Product = "product",
  Text = "text",
  Bin = "bin",
  Obstruction = "obstruction",
  Sign = "sign",
  Chest = "chest",
  PolygonalShelf = "polygonal_shelf",
  SpaceBlock = "space_block",
  Bar = "bar",
  Pegboard = "pegboard",
  MultiRowPegboard = "multi_row_pegboard",
}

export const FIXTURE_TYPES = [
  ObjectType.Shelf,
  ObjectType.Chest,
  ObjectType.PolygonalShelf,
  ObjectType.Bin,
];

// Free-floating annotation objects: never parented to a door, positioned
// directly rather than through the fixture drop/ghost-placement flow, and
// sharing the VirtualLabelContextMenu.
export const VIRTUAL_LABEL_TYPES = [ObjectType.Text, ObjectType.Sign];

export enum ObjectAction {
  ADD = "add",
  DELETE = "delete",
  UPDATE = "update",
}

export const ObjectRenderOrder: { [key: string]: number } = {
  grid: 9999,
  door: 8888,
  shelf: 7777,
  rod: 7777,
  lateral_rod: 7777,
  curved_rod: 7777,
  chest: 7777,
  polygonal_shelf: 7777,
  obstruction: 7777,
  bin: 6666,
  sign: 1111,
  allocation: 5555,
  space_block: 5555,
  product: 4444,
  text: 1111,
  bar: 7777,
  pegboard: 7777,
  multi_row_pegboard: 7777,
};

export const selectionRenderOrder: { [key: string]: number } = {
  grid: 9999,
  door: 8888,
  shelf: 4444,
  rod: 3333,
  lateral_rod: 3333,
  curved_rod: 3333,
  chest: 4444,
  polygonal_shelf: 4444,
  obstruction: 7777,
  bin: 4444,
  sign: 1111,
  allocation: 5555,
  space_block: 5555,
  product: 4444,
  text: 1111,
  bar: 4444,
  pegboard: 4444,
  multi_row_pegboard: 4444,
};

export const selectionOrder = Object.keys(selectionRenderOrder).sort(
  (a: string, b: string) => {
    return selectionRenderOrder[a] - selectionRenderOrder[b];
  },
);

export const ObjectDefaultColor = {
  shelf: "#808080",
  rod: "#808080",
  lateral_rod: "#808080",
  curved_rod: "#808080",
  chest: "#bbb100",
  bin: "#607d8b",
  polygonal_shelf: "#808080",
  obstruction: "#333333",
  sign: "#ffeb3b",
  base: "#000000",
  space_block: "#F9EDC6",
  bar: "#808080",
  pegboard: "#808080",
  multi_row_pegboard: "#808080",
};

function getCommonMenuActions(type: ObjectType) {
  return [
    {
      label: "EDITOR.COPY",
      type,
      action: "copy",
    },
    {
      label: "EDITOR.PASTE",
      type,
      action: "paste",
      disabled: true,
      actions: [
        {
          label: "EDITOR.PASTE_ALL",
          type,
          action: "paste",
        },
        {
          label: "EDITOR.PASTE_EXCLUDE_SKUs",
          type,
          action: "pasteNoSku",
        },
      ],
    },
  ];
}

export const DoorContextMenu = [
  FlyToSelectionMenuAction,
  ...getCommonMenuActions(ObjectType.Door),
  {
    label: "EDITOR.ADD_DOOR",
    type: ObjectType.Door,
    action: "add",
  },
  {
    label: "EDITOR.REMOVE_DOOR",
    type: ObjectType.Door,
    action: "delete",
  },
];

export const ShelfContextMenu = [
  {
    label: "EDITOR.ADD_SHELF",
    type: ObjectType.Shelf,
    action: "add",
    disabled: false,
  },
  {
    label: "EDITOR.REMOVE_SHELF",
    type: ObjectType.Shelf,
    action: "delete",
    disabled: false,
  },
];

export const DefaultContextMenu = [
  {
    label: "Delete",
    type: ObjectType.Shelf,
    action: "delete",
  },
];

export const VirtualLabelContextMenu = [
  {
    label: "Color",
    icon: "edit-dropdown.svg",
    type: ObjectType.Text,
    action: "color_palette_drop",
  },
  {
    label: "Add Label",
    icon: "edit-plus.svg",
    type: ObjectType.Text,
    action: "add",
    toolTipText: "BASE_GRID.ADD",
  },
  {
    label: "Edit Label",
    icon: "edit-change.svg",
    type: ObjectType.Text,
    action: "edit",
    toolTipText: "BASE_GRID.EDIT",
  },
  {
    label: "Copy",
    icon: "icon-copy-white.svg",
    type: ObjectType.Text,
    action: "copy",
    toolTipText: "BASE_GRID.COPY",
  },
  {
    label: "Paste",
    icon: "icon-clipboard-white.svg",
    type: ObjectType.Text,
    action: "paste",
    toolTipText: "BASE_GRID.PASTE",
    disabled: true,
  },
  {
    label: "Remove Label",
    icon: "edit-delete.svg",
    type: ObjectType.Text,
    action: "delete",
    toolTipText: "BASE_GRID.DELETE",
  },
];

export const DefaultToolbarMenu = [
  {
    label: "Color",
    icon: "edit-dropdown.svg",
    type: ObjectType.Text,
    action: "color_palette_drop",
  },
  {
    label: "Remove",
    icon: "edit-delete.svg",
    type: ObjectType.Text,
    action: "delete",
    toolTipText: "BASE_GRID.DELETE",
  },
];

export const OtherObjectContextMenu = {
  type: ObjectType.Chest,
  alignmentMenuActions: AlignmentMenuActions,
  RotatetMenuActions: RotateMenuActions(ObjectType.Chest),
  FlyToSelectionMenuAction: FlyToSelectionMenuAction(ObjectType.Chest),
  CloneAndContinueMenuAction: CloneAndContinueMenuAction(ObjectType.Chest),
  RepositionMenuAction: RepositionMenuAction(ObjectType.Chest),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Chest),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Chest),
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Chest),
  AutoFitToDoorMenuAction: AutoFitToDoorMenuAction(ObjectType.Chest)
};

export enum ProductFacing {
  Front = "front",
  Top = "top",
  Side = "side",
}

export enum ProductBeforeAfter {
  before = "before",
  after = "after",
}

export enum GroupUngroup {
  Group = "group",
  Ungroup = "ungroup",
}

export enum ProductRotation {
  zero = "zero",
  ninety = "ninety",
}

const OrientationMenuActions = {
  title: "MY_PLANO.ORIENTATION",
  actionsList: [
    {
      label: "MY_PLANO.ORIENTATION_FRONT",
      value: ProductFacing.Front,
      key: "face",
    },
    {
      label: "MY_PLANO.ORIENTATION_TOP",
      value: ProductFacing.Top,
      key: "face",
    },
    {
      label: "MY_PLANO.ORIENTATION_SIDE",
      value: ProductFacing.Side,
      key: "face",
    },
  ],
  rotateActionsList: [
    {
      label: "MY_PLANO.ROTATE",
      action: "rotateClockwise",
      value: ProductRotation.zero,
      key: "rotation",
    },
  ],
  rotateMenuAction: {
    label: "MY_PLANO.ROTATE",
    value: ProductRotation.zero,
    key: "rotation",
  },
};

const FacingsMenuActions = {
  title: "MY_PLANO.FACING",
  actionsList: [
    {
      label: "MY_PLANO.HORIZONTAL_FACING",
      key: "facings",
      facingKey: "x",
      value: "",
      min: 1,
      max: 150,
    },
    {
      label: "MY_PLANO.VERTICAL_FACING",
      key: "facings",
      facingKey: "y",
      value: "",
      min: 1,
      max: 20,
    },
  ],
};

const AddProductBeforeAndAfterMenuActions = {
  title: "MY_PLANO.ADD",
  actionsList: [
    {
      label: "MY_PLANO.ADD_BEFORE",
      value: ProductBeforeAfter.before,
      key: "add",
    },
    {
      label: "MY_PLANO.ORIENTATION_TOP",
      value: ProductBeforeAfter.after,
      key: "add",
    },
  ],
};

const GroupUnGroupActions = [
  {
    label: "MY_PLANO.GROUP",
    type: ObjectType.Shelf,
    action: GroupUngroup.Group,
    disabled: true,
  },
  {
    label: "MY_PLANO.UNGROUP",
    type: ObjectType.Shelf,
    action: GroupUngroup.Ungroup,
    disabled: false,
  },
];

export const ProductPropertiesMenu = {
  type: ObjectType.Product,
  orientationMenuActions: OrientationMenuActions,
  groupUnGroupActions: GroupUnGroupActions,
  addProductBeforeAndAfterMenuActions: AddProductBeforeAndAfterMenuActions,
  facingsMenuActions: FacingsMenuActions,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Product),
  skuConfigAction: {
    label: "MY_PLANO.SKU_CONFIG",
    value: "default",
    key: "sku_config",
    action: "update",
    selectOptions: [],
  },
  deleteActions: {
    label: "MY_PLANO.DELETE_SKU",
    value: "delete",
    action: "delete",
  },
};

export const ShelfPropertiesMenu = {
  type: ObjectType.Shelf,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Shelf),
  alignmentMenuActions: AlignmentMenuActions,
  groupUnGroupActions: GroupUnGroupActions,
  // RotatetMenuActions: RotateMenuActions(ObjectType.Shelf),
  FlyToSelectionMenuAction: FlyToSelectionMenuAction(ObjectType.Shelf),
  CloneAndContinueMenuAction: CloneAndContinueMenuAction(ObjectType.Shelf),
  RepositionMenuAction: RepositionMenuAction(ObjectType.Shelf),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Shelf),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Shelf),
  AutoFitToDoorMenuAction: AutoFitToDoorMenuAction(ObjectType.Shelf),
};

export const DoorPropertiesMenu = {
  type: ObjectType.Door,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Door),
  RotatetMenuActions: RotateMenuActions(ObjectType.Door),
  FlyToSelectionMenuAction: FlyToSelectionMenuAction(ObjectType.Door),
  CloneAndContinueMenuAction: CloneAndContinueMenuAction(ObjectType.Door),
  RepositionMenuAction: RepositionMenuAction(ObjectType.Door),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Door),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Door),
  DistributeShelfMenuAction: DistributeShelfMenuAction(ObjectType.Door),
  MarkAsStartPointMenuAction: MarkAsStartPointMenuAction(ObjectType.Door),
};

export const DoorPropertiesMenu2D = {
  type: ObjectType.Door,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Door),
  addDeleteMenuActions: [
    {
      label: "EDITOR.ADD_DOOR",
      type: ObjectType.Door,
      action: "add",
    },
    {
      label: "EDITOR.REMOVE_DOOR",
      type: ObjectType.Door,
      action: "delete",
    },
  ],
};

export const BinPropertiesMenu2D = {
  type: ObjectType.Bin,
  alignmentMenuActions: AlignmentMenuActions,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Bin),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Bin),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Bin),
  AutoFitToDoorMenuAction: AutoFitToDoorMenuAction(ObjectType.Bin),
};

export const ChestPropertiesMenu2D = {
  type: ObjectType.Chest,
  alignmentMenuActions: AlignmentMenuActions,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Chest),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Chest),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Chest),
  AutoFitToDoorMenuAction: AutoFitToDoorMenuAction(ObjectType.Chest),
};

export const ObstructionPropertiesMenu2D = {
  type: ObjectType.Obstruction,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Obstruction),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Obstruction),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Obstruction),
};

export const ShelfPropertiesMenu2D = {
  type: ObjectType.Shelf,
  alignmentMenuActions: AlignmentMenuActions,
  groupUnGroupActions: GroupUnGroupActions,
  copyPasteMenuActions: getCommonMenuActions(ObjectType.Shelf),
  SaveAsTemplateMenuAction: SaveAsTemplateMenuAction(ObjectType.Shelf),
  RemoveMenuAction: RemoveMenuAction(ObjectType.Shelf),
  AutoFitToDoorMenuAction: AutoFitToDoorMenuAction(ObjectType.Shelf),
};

let position: { [key: string]: any } = {
  x: 0,
  y: 0,
  z: 0,
  angle: 0,
};

export const EmptyObject = {
  id: "",
  parent_id: "",
  label: "",
  plan_id: "",
  type: "",
  position: position,
  position3d: position,
  width: 0,
  height: 0,
  depth: 0,
  properties: {
    alignment: "",
    can_combine: null,
  },
};

export enum ControlPanel {
  Undo = "undo",
  Redo = "redo",
  AddDoor = "add-door",
  TwoD = "twoD",
  ThreeD = "threeD",
  SystemRecommend = "system-recommend",
  Dashboard = "plano-dashboard",
  FixMerchandisableHeight = "align-space-even",
  TransformSelect = "transform-select",
  TransformMove = "transform-move",
  TransformRotate = "transform-rotate",
  TransformScale = "transform-scale",
  LightningMode = "lightning-mode",
  TransformMode = "transform-mode",
  Toggle2D3D = "toggle-2d-3d",
  TransformHand = "transform-hand",
  ShowHandle = "hand-planogram",
  HideHandle = "hide-hand-planogram",
  Measurements = "measurements",
  AddFlag = "add-flag",
  ShowSection = "show-section",
}

export enum MouseClick {
  IS_LEFT_MOUSE_BUTTON = 0,
  IS_RIGHT_MOUSE_BUTTON = 2,
}

export enum SocketMessageType {
  SAVE_CHANGE = "save_change",
  GET_CHANGE = "get_change",
  BROADCAST = "broadcast",
  GET_NEXT_CHANGE = "get_next_change",
  SYNC = "sync",
}

export const KeyboardShortcutsKey = [
  {
    header: "Select SKU",
    shortcuts: [
      {
        label: "Random SKU Selection",
        keys: ["", "", "", "", isMacOS() ? "Cmd" : "Ctrl", "SKU"],
      },
      {
        label: "Sequential SKU Selection",
        keys: ["", "", "", "", "Shift", "SKU"],
      },
      {
        label: "Select all SKU",
        keys: ["", "", "", "", isMacOS() ? "Cmd" : "Ctrl", "A"],
      },
    ],
  },
  {
    header: "Zoom",
    shortcuts: [
      {
        label: "Zoom In",
        keys: ["", "", "", "", isMacOS() ? "Cmd" : "Ctrl", "+"],
      },
      {
        label: "Zoom Out",
        keys: ["", "", "", "", isMacOS() ? "Cmd" : "Ctrl", "-"],
      },
      {
        label: "Reset Zoom",
        keys: ["", "", "", "", isMacOS() ? "Cmd" : "Ctrl", "0"],
      },
    ],
  },
  {
    header: "Orientation & Rotation",
    shortcuts: [
      { label: "Front Facing", keys: ["", "", "", "", "", "F"] },
      { label: "Top Facing", keys: ["", "", "", "", "", "T"] },
      { label: "SideFacing", keys: ["", "", "", "", "", "S"] },
      { label: "Rotate", keys: ["", "", "", "", "", "R"] },
    ],
  },
  {
    header: "Undo & Redo",
    shortcuts: [
      {
        label: "Undo",
        keys: ["", "", "", "", isMacOS() ? "Cmd" : "Ctrl", "Z"],
      },
      {
        label: "Redo",
        keys: [
          isMacOS() ? "Cmd" : "Ctrl",
          "Y",
          "or",
          isMacOS() ? "Cmd" : "Ctrl",
          "Shift",
          "Y",
        ],
      },
    ],
  },
  {
    header: "Set Facing of the SKU",
    shortcuts: [
      { label: "Set Horizontal Facing", keys: ["", "", "1 to 9 Keys"] },
      {
        label: "Set Vertical Facing",
        keys: ["", isMacOS() ? "Cmd" : "Ctrl", "1 to 9 Keys"],
      },
    ],
  },
  {
    header: "Door Labels",
    shortcuts: [
      {
        label: "Add Door Labels",
        keys: ["", "", "", isMacOS() ? "Cmd" : "Ctrl", "Shift", "V"],
      },
    ],
  },
  {
    header: "View Cube",
    shortcuts: [
      {
        label: "Front View",
        keys: ["", "", "", isMacOS() ? "Option" : "Alt", "F"],
      },
      {
        label: "Top View",
        keys: ["", "", "", "W"],
      },
      {
        label: "Left View",
        keys: ["", "", "", "G"],
      },
      {
        label: "Right View",
        keys: ["", "", "", "D"],
      },
      {
        label: "Clockwise Next Top Corner",
        keys: ["", "", "", "Q"],
      },
      {
        label: "Counter-Clockwise Next Top Corner",
        keys: ["", "", "", "E"],
      },
    ],
  },
  {
    header: "Canvas Navigation",
    shortcuts: [
      {
        label: "Enable Hand/Pan Mode",
        keys: ["", "", "", "", "", "H"],
      },
      {
        label: "Disable Hand/Pan Mode",
        keys: ["", "", "", "", "", "V"],
      }
    ],
  },
];

export enum Mirroring {
  TRAFFIC_FLOW = "traffic_flow",
  DOORS_SHELVES = "doors_shelves",
  DOORS_SHELVES_PRODUCTS = "doors_shelves_products",
  VIRTUAL_DOOR_LABELS = "virtual_labels",
}

export enum DoorHandle {
  LEFT = "left",
  RIGHT = "right",
  NONE = "none",
}

export const DOOR_HANDLE = {
  WIDTH: 1,
  HEIGHT: 5,
  DEPTH: 1,
};

export const BITMAP_LIMIT = 3;

export enum BitmapOptions {
  SKU_DETAIL = "sku_detail",
  OVERALL_DOS = "overall_dos",
  DOS = "dos_multiplier",
  UNIT_MOVEMENT = "unit_movement",
  PACK_TYPE = "pack_type",
  PACK_QTY = "pack_quantity",
  SEGMENT = "segment",
  BRAND = "brand",
  UNITS = "units",
  IMAGE = "image",
  CLEAR_ALL = "clear_all",
}

export const imageOrientation = [
  { label: "IMAGE_LIBRARY.FRONT", key: "front", value: "front" },
  { label: "IMAGE_LIBRARY.TOP", key: "top", value: "top" },
  { label: "IMAGE_LIBRARY.SIDE", key: "side", value: "side" },
];

export const PRODUCT_LIBRARY_DETAILS: any = {
  tableList: [
    {
      label: "",
      value: "check_box",
      valueType: "",
      filterType: "",
      inputType: "checkbox",
      // frozenColumn: true,
      sortable: false,
    },
    {
      label: "SKU Image(Front, Top, Side)",
      value: "image_json",
      valueType: "",
      filterType: "",
      // frozenColumn: true,
      inputType: "image_json",
      imageViews: imageOrientation,
    },
    {
      label: "SKU ID",
      value: "sku",
      showSkuHistory: true,
      sortable: false,
      // frozenColumn: true,
      alignFrozen: "left",
      filterType: "input_text",
      filterMatchMode: "contains",
    },
    {
      label: "SKU Name",
      value: "sku_detail",
      sortable: false,
      // frozenColumn: true,
      alignFrozen: "left",
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Segment",
      value: "segment",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Style",
      value: "style",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Manufacturer",
      value: "manufacturer",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Brand",
      value: "brand",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Category",
      value: "category",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      trimText: true,
    },
    {
      label: "Pack Type",
      value: "pack_type",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Pack Size",
      value: "pack_size",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
    {
      label: "Pack Qty",
      value: "pack_quantity",
      sortable: false,
      filterType: "input_text",
      filterMatchMode: "contains",
      colMinWidth: true,
    },
  ],
};

export const confirmDialogContent = {
  head: "RESET_PLANOGRAM.RESET",
  description: "",
  btnCancel: "GRID.CANCEL",
  btnProceed: "GRID.CONTINUE",
  showConfirmDialog: false,
  styleClass: "confirm-dialog",
  dialogkey: "reset",
};

export const planMenuActionList = [
  { label: "GRID.RENAME", action: "rename" },
  { label: "GRID.DELETE", action: "delete" },
];

export const planRenameDialogContent = {
  head: "GRID.RENAME",
  label: "GRID.PLAN_NAME",
  showPlanRenameDialog: false,
  selectedPlan: [],
  formField: {
    label: "GRID.PLAN_NAME",
    model: "name",
    placeholder: "PLANOGRAM_INFO.ENTER_PLANOGRAM_NAME",
  },
  btnCancel: "GRID.CANCEL",
  btnProceed: "GRID.PROCEED",
};

export const confirmDialogContentPlanDelete = {
  head: "GRID.DELETE_PLANOGRAM",
  description: "",
  selectedPlan: [],
  btnCancel: "GRID.CANCEL",
  btnProceed: "GRID.DELETE",
  showConfirmDialog: false,
  styleClass: "confirm-dialog",
  dialogkey: "delete",
};

export const validationErrorObjects = {
  shelfOverflow: {
    type: "error",
    count: 0,
    errorLabel: "Overflowing Shelfs",
    errors: [],
  },
  shelfStacking: {
    type: "error",
    count: 0,
    errorLabel: "Shelf stacking",
    errors: [],
  },
  shelfLabelDuplicate: {
    type: "warning",
    count: 0,
    errorLabel: "Duplicate Shelf Labels",
    errors: [],
  },
  doorLabelDuplicate: {
    type: "warning",
    count: 0,
    errorLabel: "Duplicate Door Labels",
    errors: [],
  },
  doorOverlap: {
    type: "error",
    count: 0,
    errorLabel: "Door Overlap",
    errors: [],
  },
  floatingFixtures: {
    type: "error",
    count: 0,
    errorLabel: "Floating Fixtures",
    errors: [],
  },
  productOverflow: {
    type: "warning",
    count: 0,
    errorLabel: "SKU Overflow",
    errors: [],
  },
  noImageProduct: {
    type: "warning",
    count: 0,
    errorLabel: "SKUs without image",
    errors: [],
  },
};

export const spaceBlockTemplateContent = {
  showSpaceBlockDialog: false,
  selectedSpaceBlock: {},
  loadTemplate: true,
};

export enum ConnectionStatus {
  CONNECTED = "connected",
  NOT_CONNECTED = "not-connected",
  RECONNECTING = "reconnecting",
}

export const fieldsToSyncProductKeys = [
  "width",
  "height",
  "depth",
  "sku",
  "sku_detail",
  "brand",
  "category",
  "manufacturer",
  "pack_quantity",
  "pack_size",
  "pack_type",
  "segment",
  "style",
  "image_json",
  "additional_info",
  "version",
];

export const variantsKey = ["tray", "case", "display", "alternate", "loose"];

export enum PlanVersion {
  v3_0_0 = "3.0.0",
  v3_1_0 = "3.1.0",
}

export enum ArrowKeys {
  UP = "ArrowUp",
  DOWN = "ArrowDown",
  LEFT = "ArrowLeft",
  RIGHT = "ArrowRight",
}
